import { Calendar, Clock, LogOut, User, Users } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../../../lib/supabase';
import { Logo } from '../Logo';

const navigation = [
  { name: 'Mentees', href: '/mentor/mentees', icon: Users },
  { name: 'Appointments', href: '/mentor/appointments', icon: Clock },
  { name: 'Availability', href: '/mentor/calendar/availability', icon: Calendar },
];

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      console.info(user);
      if (user?.email) {
        setUserEmail(user.email);
      }
    };
    getUser();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setUserEmail(null);
    setShowMenu(false);
    navigate('/auth/login');
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.user-menu')) {
        setShowMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <aside className="w-80 h-screen bg-white border-r fixed left-0 top-0 flex flex-col shadow-sm">
      {/* Logo */}
      <div className="p-4">
        <Logo />
      </div>

      {/* Navigation Items */}
      <nav className="flex-1 px-2 py-4">
        <div className="space-y-1">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`w-full flex items-center gap-3 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive
                    ? 'bg-[#edf5ef] text-gray-900'
                    : 'text-gray-600 hover:bg-[#edf5ef] hover:text-gray-900'
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </div>
      </nav>

      {/* User Profile Section at Bottom */}
      <div className="p-4 border-t bg-vincer-50/30">
        {userEmail && (
          <div className="relative user-menu">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="w-full flex items-center gap-3 hover:bg-white p-3 rounded-lg transition-colors"
            >
              <div className="w-9 h-9 bg-vincer-100 rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-vincer-600" />
              </div>
              <div className="flex-1 text-left">
                <span className="text-sm font-medium text-gray-900 block">{userEmail}</span>
                <span className="text-xs text-vincer-600">Mentor</span>
              </div>
            </button>

            {showMenu && (
              <div className="absolute bottom-full left-0 mb-2 w-full bg-white rounded-lg shadow-lg border">
                <button
                  onClick={handleSignOut}
                  className="w-full px-4 py-3 text-left text-gray-600 hover:bg-vincer-50 hover:text-vincer-600 flex items-center gap-2 text-sm transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  Sign Out
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </aside>
  );
} 